import React from 'react';

class Coverflow extends React.Component
{
    render()
    {
        return (
            <div className="screen-coverflow">
                <h1>Cover Flow</h1>
                <div>
                    <i className="fas fa-photo-video"></i>
                </div>
            </div>
        );
    }
};

export default Coverflow;